export default Object.freeze({
    classic: 'classic',
    nextGen: 'next_gen',
})
